import * as R from 'ramda';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

import { allDiagnosisOption } from './constants';
import { TextField } from 'Shared/form/TextField';
import SelectAllField from 'Shared/form/SelectAllField';
import SelectField from 'Shared/form/SelectField';

const optionShape = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
});

const propTypes = {
    medicationOptions: PropTypes.arrayOf(optionShape).isRequired,
    diagnosisCodeOptions: PropTypes.arrayOf(optionShape).isRequired,
    isFormLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    category: optionShape,
};

const defaultProps = {
    category: null,
    isFormLoading: false,
    isDisabled: false,
};

function ProtocolBaseForm({ category, isFormLoading, isDisabled, medicationOptions, diagnosisCodeOptions }) {
    return (
        <>
            <Row>
                <Col md={6}>
                        <SelectField
                            fieldName="category"
                            label="Therapeutic Category"
                            options={[]}
                            value={category}
                            isDisabled
                            isLoading={isFormLoading}
                            getOptionValue={R.prop('id')}
                            getOptionLabel={R.prop('name')}
                        />
                </Col>

                <Col md={6}>
                    <SelectAllField
                        fieldName="medications"
                        label="Medications"
                        required
                        placeholder="Select medications"
                        options={medicationOptions}
                        triggerPropValue="all"
                        isLoading={isFormLoading}
                        disabled={isDisabled}
                        getOptionValue={R.prop('id')}
                        getOptionLabel={R.prop('name')}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <TextField
                        fieldName="name"
                        label="Name"
                        placeholder="Enter name"
                        required
                        disabled={isDisabled}
                        style={{ height: 38 }}
                    />
                </Col>

                <Col md={6}>
                    <SelectAllField
                        fieldName="diagnosisCodes"
                        label="Diagnosis Codes"
                        placeholder="Select diagnosis codes"
                        options={diagnosisCodeOptions}
                        triggerPropValue="all"
                        isLoading={isFormLoading}
                        disabled={isDisabled}
                        getOptionValue={R.prop('id')}
                        getOptionLabel={(option) => {
                            if (R.equals(allDiagnosisOption, option)) {
                                return option.code;
                            }
                            return `${option.code}: ${option.shortDescription}`;
                        }}
                    />
                </Col>
            </Row>
        </>
    );
}

ProtocolBaseForm.propTypes = propTypes;
ProtocolBaseForm.defaultProps = defaultProps;

export default ProtocolBaseForm;
